import { useLayoutEffect, useState } from "react"
import Loading from "../loading/loading"
import { calendar_setup, month_setup, search_day } from "./setup"
import scheduleStyle from "./schedule.module.css"
import registerStyle from "../register/register.module.css"
import { schedule_load } from "../data"
import managerStyle from "manager/manager.module.css"


export default function Schedule() {

    const eventList = window.EventManager.eventList
    const todayYear = window.EventManager.todayYear
    const todayMonth = window.EventManager.todayMonth
    const selectEevent = window.EventManager.selectEevent
    const searchYear = window.EventManager.searchYear
    const Set_searchYear = window.EventManager.Set_searchYear
    const searchMonth = window.EventManager.searchMonth
    const Set_searchMonth = window.EventManager.Set_searchMonth
    const Set_statusToggle = window.EventManager.Set_statusToggle
    const firstDay = window.EventManager.firstDay
    const Set_firstDay = window.EventManager.Set_firstDay
    const lastDay = window.EventManager.lastDay
    const Set_lastDay = window.EventManager.Set_lastDay
    const selectDay = window.EventManager.selectDay

    const monthSchedule = window.EventManager.monthSchedule

    const [scheduleLoading, Set_scheduleLoading] = useState(true)
    const [calendarLoading, Set_calendarLoading] = useState(false)

    useLayoutEffect(() => {
        if(selectEevent !== null) {
            // 행사 선택시 연도와 월이 없을 경우 오늘 날짜로 설정
            if(searchYear === null && searchMonth === null) {
                Set_searchYear(todayYear)
                Set_searchMonth(todayMonth)
            }

            Set_scheduleLoading(true)
        }
    }, [selectEevent])

    useLayoutEffect(() => {
        if(searchYear !== null && searchMonth !== null) {
            // 해당 월의 첫째날과 마지막날 구하기
            const day1 = new Date(searchYear, searchMonth, 1)
            const day2 = new Date(searchYear, searchMonth + 1, 0)
            Set_firstDay(`${day1.getFullYear()}-${String(day1.getMonth() + 1).padStart(2, '0')}-${String(day1.getDate()).padStart(2, '0')}`)
            Set_lastDay(`${day2.getFullYear()}-${String(day2.getMonth() + 1).padStart(2, '0')}-${String(day2.getDate()).padStart(2, '0')}`)
        }
    }, [searchYear, searchMonth])

    useLayoutEffect(() => {
        if(firstDay && lastDay) {
            // 해당 월의 일정 불러오기
            schedule_load()
        }
    }, [firstDay, lastDay, selectEevent])

    useLayoutEffect(() => {
        if(monthSchedule !== null) {
            // 일정을 불러온 후 달력 설정
            const result = calendar_setup({
                schedule: monthSchedule,
                firstDay: firstDay,
                lastDay: lastDay
            })

            if(result) {
                Set_scheduleLoading(false)
                Set_calendarLoading(false)
            }
        }
    }, [monthSchedule])

    useLayoutEffect(() => {
        for(let i=0; i<selectDay.length; i++) {
            const target = selectDay[i]['target']
            target.classList.add(scheduleStyle.selectedDay)
        }
    }, [selectDay])

    if(selectEevent === null) {
        return(
            <div className={scheduleStyle['scheduleWrap']}>
                <div className={managerStyle['alarm']}>행사를 선택해 주세요.</div>
            </div>
        )
    }
    else {
        return(
            <div className={scheduleStyle['scheduleWrap']}>
                <Loading
                    loading={scheduleLoading}
                ></Loading>

                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "5px"
                    }}
                >
                    <div className={managerStyle['label']}>{selectEevent['name']}</div>

                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <button
                            type="button"
                            className={`
                                ${managerStyle['button']}
                                ${managerStyle['dark']}
                            `}
                            style={{
                                width: "30px",
                                height: "30px",
                                marginInline: "10px"
                            }}
                            onClick={() => month_setup({
                                value: -1,
                                Set_calendarLoading: Set_calendarLoading
                            })}
                        >{'<'}</button>
                        <div className={registerStyle.input_date}>
                            <input
                                type="month"
                                onChange={(e) => search_day({
                                    value: e.currentTarget.value,
                                    Set_calendarLoading: Set_calendarLoading
                                })}
                                value={`${searchYear}-${String(searchMonth + 1).padStart(2, '0')}`}
                            ></input>
                        </div>
                        <button
                            className={`
                                ${managerStyle['button']}
                                ${managerStyle['dark']}
                            `}
                            style={{
                                width: "30px",
                                height: "30px",
                                marginInline: "10px"
                            }}
                            onClick={() => month_setup({
                                value: +1,
                                Set_calendarLoading: Set_calendarLoading
                            })}
                        >{'>'}</button>
                    </div>

                    <button
                        type="button"
                        className={`
                            ${managerStyle['button']}
                            ${managerStyle['dark']}
                        `}
                        style={{
                            width: "70px",
                            height: "30px"
                        }}
                        onClick={() => {
                            Set_statusToggle(true)
                        }}
                    >현황</button>
                </div>

                <div
                    style={{
                        position: "relative",
                        width: "100%",
                        height: "100%",
                        overflow: "auto"
                    }}
                >
                    <Loading
                        loading={calendarLoading}
                    ></Loading>

                    <table className={scheduleStyle.calendar}>
                        <thead>
                            <tr>
                                {Array
                                .from(['일', '월', '화', '수', '목', '금', '토'])
                                .map((value, index) => {
                                    return(
                                        <th
                                            key={index}
                                        >{value}</th>
                                    )
                                })}
                            </tr>
                        </thead>

                        <tbody id="calendar_day"></tbody>

                        <tfoot></tfoot>
                    </table>
                </div>
            </div>
        )
    }
}